module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_main_hokubu_beach-23e86639d047ec2dff9112e843d1b7a6.jpg";